import { render, staticRenderFns } from "./merchantexportrecord.vue?vue&type=template&id=d9a07138&scoped=true"
import script from "./merchantexportrecord.vue?vue&type=script&lang=ts"
export * from "./merchantexportrecord.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9a07138",
  null
  
)

export default component.exports